/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:35:58AM]
Permissions to update outside the main branch: [false]
*/

import { PendingProvider } from '@finbeat/react-toolkit';
import {
    sidebarEmployerPortalUserMenu,
    sidebarMenu,
} from 'components/Navigation/Sidebar/sidebarMenu';
import useAuth from 'hooks/useAuth';
import { SidebarProvider } from 'providers/SidebarProvider';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import './MainSpace.scss';
import Sidebar from 'components/Navigation/Sidebar/Sidebar';

const MainSpace = () => {
    const { i18n } = useTranslation();
    const { auth } = useAuth();
    const className = 'main-space';

    const menu = useMemo(() => {
        if (!auth) return [];

        if (auth.portalUserEmployerId) return sidebarEmployerPortalUserMenu;

        return sidebarMenu;
    }, [auth]);

    useEffect(() => {
        auth?.portalUserEmployerId && i18n.changeLanguage('en');
    }, [auth]);

    return (
        <div className={className}>
            <div className={`${className}__body`}>
                <SidebarProvider mainMenu={menu}>
                    <Sidebar />
                </SidebarProvider>
                <div className={`${className}__workspace`}>
                    <main className={`${className}__content`}>
                        <PendingProvider>
                            <Outlet />
                        </PendingProvider>
                    </main>
                </div>
            </div>

            {auth?.portalUserEmployerId && (
                <div className={`${className}__footer`}>
                    <div className="area">
                        <div className="block">
                            <span>NBFC Partner</span>
                            <span>FincFriends Private Limited</span>
                        </div>
                        <div className="block">
                            <span>CIN: U36737286KA74834</span>
                            <span>©2023 NOVA MONEY SOLUTION PVT LTD</span>
                        </div>
                    </div>

                    <div className="area">
                        <div className="block align-items-end">
                            <span>NOVA MONEY SOLUTION PVT LTD is a part of DFI group,</span>
                            <span>a leading financial services provider in global market.</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MainSpace;
